
export const properties = {
    debugLog: false && process.env.NODE_ENV !== "production",
    apiDomain : "/api",
    webAppDomain: 'http://192.168.178.55:3000',
};
